/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { CustomFieldDefinition } from '../models/CustomFieldDefinition';
import { CustomFieldDefinitionList } from 'src/app/common/fancy-firebase/lists/CustomFieldDefinitionList';
import { filterMap } from 'src/app/utils/map-util';

export class CustomFieldDefinitions extends FancyActionableFirebase<
	CustomFieldDefinition,
	FancyAction,
	CustomFieldDefinitionList
> {
	constructor(public data: CustomFieldDefinitionList) {
		super(data);
	}
}

export function filterDisabledDefinitions(
	srcMap: Map<string, CustomFieldDefinition>
): Map<string, CustomFieldDefinition> {
	return filterMap(srcMap, (k: string, def: CustomFieldDefinition) => def.view.isEnabled);
}
